import React, { useMemo } from 'react';
import { Typography } from '../typography/typography';
import { isString } from './utils';
import styles from './styles/infobar.module.css';
export const InfobarContent = ({
  children,
  title
}) => {
  const renderTitle = useMemo(() => {
    if (isString(title)) {
      return /*#__PURE__*/React.createElement(Typography, {
        variant: "m",
        size: "body_accent",
        "data-testid": "infobar-title"
      }, title);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, title);
  }, [title]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.content,
    "data-testid": "infobar-content"
  }, title && renderTitle, children && (/*#__PURE__*/React.createElement(Typography, {
    className: styles.text,
    variant: "s",
    size: "body_long",
    "data-testid": "infobar-text"
  }, children)));
};